import api from '@/libs/axios'
import { Article, NewsModel, SearchNewsModel } from '@/api/models/accesPlateformeBeneficiaires/news';
import { PaginatedList } from '@/api/models/common/paginatedList';

const resource = 'News'

export default class PtfBeneficiaireNewsResource {

  public async createNews(data : NewsModel) : Promise<void> {
    let formData = new FormData();

    if (data.image) {
      formData.append("image", data.image);
    }

    formData.append("titre", data.titre);

    formData.append("resume", data.resume);

    formData.append("motCles", JSON.stringify(data.motCles));

    formData.append("tags", JSON.stringify(data.tags));

    formData.append(
      "contenu",
      data.contenu.toString()
    );

    const response = await api.post(`${resource}`, formData)
    return response.data
  }

  public async updateNews(id: string, data: NewsModel): Promise<void> {
    let formData = new FormData();

    formData.append("id", id);

    if (data.image) {
      formData.append("image", data.image);
    }

    formData.append("titre", data.titre);

    formData.append("resume", data.resume);

    formData.append("motCles", JSON.stringify(data.motCles));

    formData.append("tags", JSON.stringify(data.tags));

    formData.append(
      "contenu",
      data.contenu.toString()
    );

    const response = await api.put(`${resource}/${id}`, formData)
    return response.data
  }

  public async deleteNews(id: string): Promise<void> {
    const response = await api.delete(`${resource}/${id}`)
    return response.data
  }

  public async searchNews(searchModel: SearchNewsModel): Promise<PaginatedList<Article>> {
    const response = await api.post(`${resource}/search`, searchModel)
    return response.data
  }
}